import { Modal } from 'react-bootstrap';
import EditDocumentDetailInfo from '../detail-edit/edit-document-detail-info';

const EditDocumentDetailModal = (props: any) => {
    const { onClose, onUpdated, isOpen, data } = props;

    return (
        <Modal
            show={isOpen}
            onHide={onClose}
            centered
            size={'lg'}
            className="update-document-modal"
        >

            <EditDocumentDetailInfo data={data} onClose={onClose} onUpdated={onUpdated} />                                             
        </Modal>
    );
};

export default EditDocumentDetailModal;
